import React from 'react';

import { withCommon, SignUpForm, SimpleSignUpForm } from '../../../components';


const SignupDrawer = withCommon({
    store: ({ store }) => ({
        simpleSignup: store.site.simpleSignup,
        easyMembership: store.site.easyMembership.enabled,
    }),
    defaultName: 'SignupDrawer',
    isTrans: true,
    isObserver: true,
})(({simpleSignup, easyMembership}) => {
    return (
        <div className={`signup-drawer${easyMembership ? ' signup-drawer--easy' : ''}`}>
            {simpleSignup
            ? <SimpleSignUpForm />
                : <SignUpForm />}
        </div>
    );
});

export default SignupDrawer;
